enum Web {
  'login' = '/login',
  'password' = '/password',
  'forgottenPassword' = '/password/reset',
  'changePassword' = '/password/change/:token',
}

export default Web;
